import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { updateComponent, selectSelectedComponent } from '../../../redux/editorSlice';
import { usePropertyPanel } from '../PropertyPanelContext';
import { PaddingControl } from '../CommonProperties';

const MobileLayoutProperties = () => {
  // 선택된 컴포넌트 가져오기
  const selectedComponent = useSelector(selectSelectedComponent);
  const dispatch = useDispatch();
  
  // 컨텍스트에서 필요한 함수들 가져오기
  const { handleStyleChange } = usePropertyPanel();
  
  // 메뉴 아이템 상태 관리
  const [menuItems, setMenuItems] = useState([]);
  
  // 컴포넌트 데이터 초기화
  useEffect(() => {
    if (selectedComponent) {
      const componentProps = selectedComponent.componentProps || {};
      setMenuItems(componentProps.menuItems || [
        { label: '내 정보', path: '/mydata' },
        { label: '자산정보', path: '/points' },
        { label: '추천인', path: '/recommendee' },
        { label: '계보도', path: '/legs' },
        { label: '멤버십투자', path: '/getmembership' },
        { label: '수당요약', path: '/getPaybacks' }
      ]);
    }
  }, [selectedComponent]);

  // 컴포넌트가 없으면 렌더링하지 않음
  if (!selectedComponent) return null;

  const componentProps = selectedComponent.componentProps || {};
  
  // 속성 업데이트 함수
  const updateComponentProps = (key, value) => {
    dispatch(updateComponent({
      id: selectedComponent.id,
      changes: {
        componentProps: {
          ...componentProps,
          [key]: value
        }
      }
    }));
  };

  // 스타일 업데이트 함수
  const updateStyle = (key, value) => {
    if (!selectedComponent) return;
    
    const existingStyle = JSON.parse(JSON.stringify(selectedComponent.style || {}));
    existingStyle[key] = value;
    
    dispatch(updateComponent({
      id: selectedComponent.id,
      changes: {
        style: existingStyle
      }
    }));
  };

  // 메뉴 아이템 업데이트 함수
  const updateMenuItems = (newItems) => {
    setMenuItems(newItems);
    updateComponentProps('menuItems', newItems);
  };

  return (
    <>
      <div className="property-group">
        <div className="property-group-title">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 5H21V7H3V5Z" fill="currentColor" />
            <path d="M3 11H21V13H3V11Z" fill="currentColor" />
            <path d="M3 17H21V19H3V17Z" fill="currentColor" />
          </svg>
          모바일 메뉴 설정
        </div>
        
        {/* 기본 설정 */}
        <div className="property-control">
          <label>화살표 표시</label>
          <input 
            type="checkbox" 
            checked={componentProps.showArrows !== false} 
            onChange={(e) => updateComponentProps('showArrows', e.target.checked)}
          />
        </div>
        
        <div className="property-control">
          <label>스크롤 이동량</label>
          <input 
            type="number" 
            value={componentProps.scrollAmount || 100} 
            min={50} 
            max={500} 
            step={10} 
            onChange={(e) => updateComponentProps('scrollAmount', parseInt(e.target.value))}
          />
        </div>
      </div>
      
  
      
      {/* 메뉴 항목 */}
      <div className="property-group">
        <div className="property-group-title">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4 6H20M4 12H20M4 18H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          메뉴 항목
        </div>
        
        <div style={{ 
          maxHeight: '300px',
          overflowY: 'auto',
          border: '1px solid #eee', 
          borderRadius: '4px',
          padding: '8px',
          margin: '8px 0'
        }}>
          {menuItems.map((item, index) => (
            <div 
              key={index} 
              className="dynamic-list-item"
              style={{
                padding: '8px',
                marginBottom: '8px',
                backgroundColor: '#f9fafb',
                borderRadius: '4px',
                boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)'
              }}
            >
              <div className="property-control">
                <label>메뉴명</label>
                <input
                  type="text"
                  value={item.label}
                  onChange={(e) => {
                    const newItems = [...menuItems];
                    newItems[index] = { ...item, label: e.target.value };
                    updateMenuItems(newItems);
                  }}
                  style={{
                    width: '100%',
                    padding: '6px',
                    borderRadius: '4px',
                    border: '1px solid #d1d5db'
                  }}
                />
              </div>
              
              <div className="property-control">
                <label>경로</label>
                <input
                  type="text"
                  value={item.path}
                  onChange={(e) => {
                    const newItems = [...menuItems];
                    newItems[index] = { ...item, path: e.target.value };
                    updateMenuItems(newItems);
                  }}
                  style={{
                    width: '100%',
                    padding: '6px',
                    borderRadius: '4px',
                    border: '1px solid #d1d5db'
                  }}
                />
              </div>
              
              <button
                className="delete-button"
                onClick={() => {
                  const newItems = [...menuItems];
                  newItems.splice(index, 1);
                  updateMenuItems(newItems);
                }}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: '4px 8px',
                  marginTop: '4px',
                  backgroundColor: '#ef4444',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  fontSize: '12px',
                  transition: 'background-color 0.2s ease'
                }}
              >
                <svg 
                  style={{ marginRight: '4px' }} 
                  width="12" 
                  height="12" 
                  viewBox="0 0 24 24" 
                  fill="none" 
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M6 18L18 6M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                삭제
              </button>
            </div>
          ))}
        </div>
        
        <button
          className="add-menu-button"
          onClick={() => {
            updateMenuItems([...menuItems, { label: '', path: '' }]);
          }}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            padding: '8px 12px',
            margin: '10px 0',
            backgroundColor: '#3b82f6',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '14px',
            transition: 'background-color 0.2s ease'
          }}
        >
          <svg 
            style={{ marginRight: '8px' }} 
            width="16" 
            height="16" 
            viewBox="0 0 24 24" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M12 6V18M6 12H18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          메뉴 추가
        </button>
      </div>
      
          {/* 스타일 설정 */}
          <div className="property-group">
        <div className="property-group-title">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="currentColor" strokeWidth="2" />
            <path d="M7 12H17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            <path d="M12 7V17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          </svg>
          색상 및 스타일
        </div>
        
        <div className="property-control">
          <label>배경색</label>
          <input 
            type="color" 
            value={componentProps.backgroundColor || '#ffffff'} 
            onChange={(e) => updateComponentProps('backgroundColor', e.target.value)}
          />
        </div>
        
        <div className="property-control">
          <label>텍스트 색상</label>
          <input 
            type="color" 
            value={componentProps.textColor || '#000000'} 
            onChange={(e) => updateComponentProps('textColor', e.target.value)}
          />
        </div>
        
        <div className="property-control">
          <label>선택 텍스트 색상</label>
          <input 
            type="color" 
            value={componentProps.activeTextColor || '#3b82f6'} 
            onChange={(e) => updateComponentProps('activeTextColor', e.target.value)}
          />
        </div>
        
        <div className="property-control">
          <label>하단 테두리</label>
          <input 
            type="text" 
            value={selectedComponent.style?.borderBottom || '1px solid #ccc'} 
            onChange={(e) => updateStyle('borderBottom', e.target.value)}
          />
        </div>
      </div>
      {/* <PaddingControl /> */}
    </>
  );
};

export default MobileLayoutProperties; 